import util from '@/libs/util'

const post = util.ajax.post

export const ordermainUrls = [
  // 查询尾气检测列表
  '/statisticsvehiclemonth/list'
]

export const ordermain = {}

ordermain.listOrder = function (params) {
  return post('/statisticsvehiclemonth/list', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/order/ordermain.js